(function () {
  'use strict';

  /* ============================================================
   * SECTION 1 — Filtro pill Tutti / In offerta / Set & Routine / Second Life
   * ============================================================ */
  var VALID_SEGMENTS = ['all', 'offerta', 'set', 'secondlife'];
  var PARAM_KEY = 'show';
  var BODY_ATTR = 'data-collection-segment';

  function getInitialSegment() {
    try {
      var url = new URL(window.location.href);
      var value = url.searchParams.get(PARAM_KEY);
      if (value && VALID_SEGMENTS.indexOf(value) !== -1) return value;
    } catch (e) {}
    return 'all';
  }

  function applySegment(root, segment) {
    if (segment === 'all') {
      document.body.removeAttribute(BODY_ATTR);
    } else {
      document.body.setAttribute(BODY_ATTR, segment);
    }
    var pills = root.querySelectorAll('.collection-segments__pill');
    pills.forEach(function (pill) {
      var isActive = pill.getAttribute('data-segment') === segment;
      pill.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
    // Ridipingi i bordi quando cambia il segmento attivo (alcuni card cambiano visibilità)
    requestAnimationFrame(refreshSLBorders);
  }

  function updateUrl(segment) {
    try {
      var url = new URL(window.location.href);
      if (segment === 'all') {
        url.searchParams.delete(PARAM_KEY);
      } else {
        url.searchParams.set(PARAM_KEY, segment);
      }
      var newUrl = url.pathname + (url.search ? url.search : '') + url.hash;
      window.history.replaceState({}, '', newUrl);
    } catch (e) {}
  }

  function initPills() {
    var root = document.querySelector('[data-collection-segments]');
    if (!root) return;
    var initial = getInitialSegment();
    applySegment(root, initial);
    root.addEventListener('click', function (event) {
      var pill = event.target.closest('.collection-segments__pill');
      if (!pill || !root.contains(pill)) return;
      var segment = pill.getAttribute('data-segment');
      if (!segment || VALID_SEGMENTS.indexOf(segment) === -1) return;
      applySegment(root, segment);
      updateUrl(segment);
    });
  }

  /* ============================================================
   * SECTION 2 — Bordo verde Second Life (SVG path generato per card)
   *
   * Genera un path SVG che traccia il perimetro completo della card
   * (rettangolo arrotondato + curva del notch concavo per il carrello),
   * con stroke 3px uniforme indipendente dall'aspect ratio.
   *
   * Il path è scritto in viewBox = dimensioni effettive della card,
   * cosi' nessuna distorsione angolare. Stroke esce 3px in screen px.
   * ============================================================ */
  var SL_STROKE_WIDTH = 3;
  var SL_COLOR = '#8bc883';
  var SL_RADIUS = 10;
  var SL_HALO = 10;

  function getQbSize(el) {
    // Leggi --qb-size dal CARD specifico (44 desktop, 36 mobile).
    var source = el || document.documentElement;
    var v = getComputedStyle(source).getPropertyValue('--qb-size');
    var n = parseFloat(v);
    if (!isFinite(n) || n <= 0) {
      v = getComputedStyle(document.documentElement).getPropertyValue('--qb-size');
      n = parseFloat(v);
    }
    if (!isFinite(n) || n <= 0) {
      n = window.innerWidth < 750 ? 36 : 44;
    }
    return n;
  }

  function buildSLPath(W, H, qbSize, halo, r) {
    // qbSize: dimensione del cart button (44 desktop, 36 mobile)
    // halo: pixel di respiro attorno al cart button (10)
    // r: corner radius della card (10)
    //
    // ALTERNATIVA BRILLANTE: cutout CIRCOLARE concentrico al cart button.
    // Path = rounded rect con il bottom-right corner sostituito da un SINGOLO arco
    // concentrico al cart button. Geometricamente perfetto, halo uniforme 360°,
    // niente "middle angles" come l'L-shape.

    var corner = r;
    var cartHalf = qbSize / 2;
    var cartCx = W - cartHalf;
    var cartCy = H - cartHalf;
    var cutoutR = cartHalf + halo;

    // Cerchio cutout interseca bordo destro (x=W) ai punti y = cartCy ± dyEdge
    var dyEdge = Math.sqrt(cutoutR * cutoutR - cartHalf * cartHalf);
    var yArcStart = cartCy - dyEdge;     // upper intersection (dentro card)
    var xArcEnd   = cartCx - dyEdge;     // simmetrica sul bordo bottom

    function n(v) { return Math.round(v * 100) / 100; }

    // Sweep dell'arco: dal punto di intersezione sul bordo destro,
    // CCW visuale (passing through upper-left side del cart button),
    // fino al punto di intersezione sul bordo inferiore.
    // Total sweep ~199° → large-arc-flag=1, sweep-flag=0.
    return (
      'M ' + corner + ' 0 ' +
      'L ' + n(W - corner) + ' 0 ' +
      'A ' + corner + ' ' + corner + ' 0 0 1 ' + W + ' ' + corner + ' ' +
      'L ' + W + ' ' + n(yArcStart) + ' ' +
      // Single arc — cutout concentric con cart button
      'A ' + cutoutR + ' ' + cutoutR + ' 0 1 0 ' + n(xArcEnd) + ' ' + H + ' ' +
      'L ' + corner + ' ' + H + ' ' +
      'A ' + corner + ' ' + corner + ' 0 0 1 0 ' + n(H - corner) + ' ' +
      'L 0 ' + corner + ' ' +
      'A ' + corner + ' ' + corner + ' 0 0 1 ' + corner + ' 0 ' +
      'Z'
    );
  }

  function paintSLCard(card) {
    var img = card.querySelector('.product-item__image');
    if (!img) return;
    var rect = img.getBoundingClientRect();
    var W = Math.round(rect.width);
    var H = Math.round(rect.height);
    if (W < 40 || H < 40) return; // card non ancora dimensionata, riprovo dopo

    var qbSize = getQbSize(card);
    var d = buildSLPath(W, H, qbSize, SL_HALO, SL_RADIUS);

    var svg =
      '<svg xmlns="http://www.w3.org/2000/svg" width="' + W + '" height="' + H + '" ' +
      'viewBox="0 0 ' + W + ' ' + H + '" preserveAspectRatio="none">' +
      '<path d="' + d + '" stroke="' + SL_COLOR + '" stroke-width="' + SL_STROKE_WIDTH + '" ' +
      'fill="none" stroke-linejoin="round" stroke-linecap="butt" vector-effect="non-scaling-stroke"/>' +
      '</svg>';

    var dataUrl = 'url("data:image/svg+xml;utf8,' + encodeURIComponent(svg) + '")';
    card.style.setProperty('--sl-border-svg', dataUrl);
    card.setAttribute('data-sl-painted', '1');
  }

  function refreshSLBorders() {
    var cards = document.querySelectorAll('grid-item[data-segment="secondlife"]');
    cards.forEach(paintSLCard);
  }

  function initBorders() {
    refreshSLBorders();
    // Re-render quando le immagini caricano (alcune card si dimensionano dopo)
    var imgs = document.querySelectorAll('grid-item[data-segment="secondlife"] img');
    imgs.forEach(function (img) {
      if (!img.complete) {
        img.addEventListener('load', refreshSLBorders, { once: true });
      }
    });
    // Re-render su resize (debounced)
    var t = null;
    window.addEventListener('resize', function () {
      if (t) clearTimeout(t);
      t = setTimeout(refreshSLBorders, 150);
    });
    // Re-render dopo paint completo
    window.addEventListener('load', refreshSLBorders);
  }

  /* ============================================================
   * Boot
   * ============================================================ */
  function boot() {
    initPills();
    initBorders();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
